import { IRootState } from '../../../store'
import { IPaymentInformationOptionState } from '../store/options.types'

export const getPaymentInformationOptionsSelector = (state: IRootState): IPaymentInformationOptionState =>
  state.options.paymentInformationOptions
